<!-- src/layouts/AppLayout.vue -->
<template>
  <Loader v-if="appStore.isLoading" />
  <router-view />
  <NavbarMobile />
</template>

<script setup>
import { useAppStore } from "@/stores/appStore";
import Loader from "@/components/Loader";
import NavbarMobile from "@/components/NavbarMobile";

const appStore = useAppStore();
</script>

<style scoped></style>
